import { ISchedule, ICalendarInfo } from 'tui-calendar'
import { Language, LocalizedString } from "../language"
import { format } from '../format'
import { Config } from '../constants'
import { ColorType } from '../Components/Control'

export interface Program {
	IsAvailable: boolean
	ProgramId: number
	ProgramName: LocalizedString 
	Workshops: Array<Workshop>
}

export interface Workshop {
	WorkshopId: number
	WorkshopName: LocalizedString
	WorkshopNumber: string
	Description: LocalizedString
	Prerequisites: LocalizedString
	Events: Array<WorkshopEvent>
}

export interface WorkshopEvent {
	EventId: number
	Instructor: Instructor
	IsActive: boolean
	IsCancelled: boolean
	IsInProgress: boolean
	IsParticipating: boolean
	LanguageId: number
	Location: Location
	MaximumParticipants: number
	ParticipantInstructions: string
	Schedule: Array<Schedule>
	SeatsLeft: number
	StatusId: number
	WorkshopTypeId: number
}

export interface Instructor {
	InstructorId: number
	EmailAddress: string
	FirstName: string
	LastName: string
	Phone: string
}

export interface Location {
	LocationId: number
	AddressLine1: string
	City: string
	FullAddress: string
	MunicipalityTier1Id: number
	MunicipalityTier2Id: number
	MunicipalityTier1Name: string
	MunicipalityTier2Name: string
	Name: string
	Province: string
}

export interface Schedule {
	ScheduleId: number
	EventId: string
	InstructorId: number
	StartDateAndTime: Date
	EndDateAndTime: Date
	Room: string
	StatusId: number
}


interface TuiProps {
	calendars: Array<ICalendarInfo>
	schedules: Array<ISchedule>
}

export function getTuiScheduleProps(workshop: Workshop, filteredEvents: Array<WorkshopEvent>, language: Language): TuiProps {
	const calendarId = 'workshop-events'

	const calendars: Array<ICalendarInfo> = [
		{ 
			id: calendarId, 
			name: 'Workshop Events', 
		}
	]

	const schedules: Array<ISchedule> = filteredEvents.flatMap(event => event.Schedule.map((schedule, scheduleIndex) => {

		let title = workshop.WorkshopName[language]
		if (event.Schedule.length > 1) {
			title += ` (${scheduleIndex + 1})`
		}

		const iSchedule: ISchedule = {
			id: schedule.ScheduleId.toString(),
			calendarId, 
			category: 'time',
			start: schedule.StartDateAndTime.toISOString(), 
			end: schedule.EndDateAndTime.toISOString(), 
			title,
			raw: { workshopEventId: event.EventId, isParticipating: event.IsParticipating }
		}
		return iSchedule
	}))

	return { calendars, schedules }
}

export function shouldShowRegistrationCutoffNotice(workshopEvent: WorkshopEvent): ColorType | undefined {
	let now = new Date()

	let warningDate = new Date(workshopEvent.Schedule[0].StartDateAndTime)
	let dangerDate = new Date(workshopEvent.Schedule[0].StartDateAndTime)

	warningDate.setHours(warningDate.getHours() - Config.HoursUntilRegistrationCutoff - Config.HoursUntilRegistrationCutoffNotificationWarning)
	dangerDate.setHours(dangerDate.getHours() - Config.HoursUntilRegistrationCutoff - Config.HoursUntilRegistrationCutoffNotificationDanger)

	if (now > dangerDate) return 'danger'
	else if (now > warningDate) return 'warning'
}

export function getFriendlyDurationToEventCutoff(workshopEvent: WorkshopEvent) {
	let cutoffDate = new Date(workshopEvent.Schedule[0].StartDateAndTime)

	cutoffDate.setHours(cutoffDate.getHours() - Config.HoursUntilRegistrationCutoff)

	return format.friendlyDurationTo(cutoffDate)
}

export const getWorkshopEventHtmlId = (event: WorkshopEvent) => `workshop-event-${event.EventId}`
